// extracted by mini-css-extract-plugin
module.exports = {"container":"organization-img_container__3zyCM","image":"organization-img_image__3iJiA","name":"organization-img_name__350KS"};